import React from 'react';
import { IProps } from './type';

const CartIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5 5.875C4.5 5.05313 4.5 4.64219 4.72699 4.36561C4.76854 4.31497 4.81497 4.26854 4.86561 4.22699C5.14219 4 5.55313 4 6.375 4V4C7.19687 4 7.60781 4 7.88439 4.22699C7.93503 4.26854 7.98146 4.31497 8.02301 4.36561C8.25 4.64219 8.25 5.05313 8.25 5.875V7.18182C8.25 8.12463 8.25 8.59603 8.54289 8.88892C8.83579 9.18182 9.30719 9.18182 10.25 9.18182H12H13.75C14.6928 9.18182 15.1642 9.18182 15.4571 8.88892C15.75 8.59603 15.75 8.12463 15.75 7.18182V5.875C15.75 5.05313 15.75 4.64219 15.977 4.36561C16.0185 4.31497 16.065 4.26854 16.1156 4.22699C16.3922 4 16.8031 4 17.625 4V4C18.4469 4 18.8578 4 19.1344 4.22699C19.185 4.26854 19.2315 4.31497 19.273 4.36561C19.5 4.64219 19.5 5.05313 19.5 5.875V13.8182V17.9394V17.9394C19.5 17.9957 19.5 18.0238 19.4994 18.0476C19.474 19.1149 18.6149 19.974 17.5476 19.9994C17.5238 20 17.4957 20 17.4394 20H6.56061C6.50433 20 6.4762 20 6.4524 19.9994C5.38513 19.974 4.52597 19.1149 4.50057 18.0476C4.5 18.0238 4.5 17.9957 4.5 17.9394V17.9394V13.8182V5.875Z"
        stroke={strokeColor || fillColor || "#212121"} />
    </svg>
  )
};

export default CartIcon;
